import { useMemo } from "react";
import { Alert, Button, Col, Row } from "react-bootstrap";
import type { SerializedObject, UnpackResponse } from "../../../api/src/lib";
import type { ProfileController } from "../../../api/src/profile/profile.controller";
import type { TasksController } from "../../../api/src/tasks/tasks.controller";
import Loading from "../Loading";
import TabContainerWithTabs from "../components/TabContainer";
import { useAuthenticatedFetch } from "../lib/api";
import TaskList from "../tasks/TaskList";
import { deserializeTask } from "../tasks/lib";
import DashboardNav from "./DashboardNav";

const AssignedTasks = () => {
  const {
    isPending: isPendingProfile,
    isError: isErrorProfile,
    refetch: refetchProfile,
    data: dataProfile,
  } = useAuthenticatedFetch<UnpackResponse<ProfileController["getProfile"]>>(
    "/profile",
  );
  const user = dataProfile?.data;

  const {
    isFetching: isFetchingTasks,
    isError: isErrorTasks,
    refetch: refetchTasks,
    data: dataTasks,
  } = useAuthenticatedFetch<
    SerializedObject<UnpackResponse<TasksController["getAllAssignedTasks"]>>
  >("/tasks/assigned", undefined, {
    enabled: user?.connections.wealthbox ?? false,
  });
  const tasks = useMemo(
    () =>
      (dataTasks?.data ?? [])
        .map(deserializeTask)
        .filter((task) => task.complete !== true),
    [dataTasks?.data],
  );

  return (
    <TabContainerWithTabs tabs={DashboardNav}>
      <Row>
        <Col>
          {isErrorProfile || isErrorTasks ? (
            <Alert variant="danger">
              Failed to load tasks{" "}
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => {
                  if (isErrorProfile) refetchProfile();
                  if (isErrorTasks) refetchTasks();
                }}
              >
                Try again
              </Button>
            </Alert>
          ) : isPendingProfile ? (
            <Loading message="Tasks" />
          ) : (!isFetchingTasks && tasks.length <= 0) ||
            !(user?.connections.wealthbox ?? false) ? (
            <Alert>No Tasks</Alert>
          ) : isFetchingTasks ? (
            <Loading message="Tasks" />
          ) : (
            <TaskList tasks={tasks} hideAssignee />
          )}
        </Col>
      </Row>
    </TabContainerWithTabs>
  );
};

export default AssignedTasks;
